import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import axios from 'src/app/Service/axios';
import axios_2 from 'src/app/Service/axios-dotone';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { Location } from '@angular/common';
import { BingMaps, XYZ } from 'ol/source';
import { defaults as defaultControls, FullScreen } from 'ol/control';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';

declare let $: any;

@Component({

  selector: 'tracker',

  templateUrl: './tracker.component.html',

  styles: [`

      p,span{

        font-size:clamp(14px,2vw,17px)

      },

      .col-12 img {
          max-height: 800px;
      }

      .row img {
          width: 100%;
          height: 100%;
          object-fit: cover;
      }


  `]

})

export class TrackerComponent implements OnInit, OnDestroy {

  map: any = {};

  car: any;

  Id: string = "0";

  point: Array<any> = [];

  pointLive: Array<any> = [];

  flon: any;

  fLat: any;

  interval: any;

  Name: string = "";

  Plak: string = "";

  speed: string = "";

  strTime: string = "";

  mapSatelait: boolean = false;

  bCarList: boolean = false;

  bDashCam: boolean = false;

  bShowOptions: boolean = false;

  layers: any = [];

  tooltipData: any;

  source: any;

  vector: any;

  groupCar: any;

  domain: any;

  fDistance: any = 0;

  iTempAccess: number = 0;

  tripId!: number;

  ScreenShot!: boolean;

  strClientId!: string;

  tiChannel!: number;

  bDotOneMap: boolean = true;

  strValidTime!: string;

  lastCallTime: string = '';

  lst_checked: any = [];

  constructor(

    private el: ElementRef,

    private notifyService: NotificationService,

    private router: Router,

    private otherService: OtherService,

    private mapService: MapService,

    private route: ActivatedRoute,

    private _location: Location,

    private gurdService: GurdServiceService

  ) { }

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  ngOnInit(): void {

    this.route.url.subscribe((segment) => {

      if (segment[0].path == 'carList-Tracker') {

        this.bCarList = true;

        setTimeout(() => {

          this.newOpenMap();

          let res = JSON.parse(this.gurdService.decrypt(localStorage.getItem('XmeTCrsX5GCZ')!).toString());
  
          res.forEach((el: any, i: any) => {
  
            if (this.point.length != 0) {
  
              this.mapService.removeMarkerById(`route${el.strUnitID}`, this.map);
  
              this.mapService.removeMarkerById(`route${el.strUnitID}_start`, this.map);
  
              this.mapService.removeMarkerById(`route${el.strUnitID}_end`, this.map);
  
              this.mapService.removeLayerByName(`ArrowName`, this.map);
  
              this.mapService.removeLayerByName(`route_line`, this.map);
  
              this.mapService.removeLayerByName(`route_point`, this.map);
  
            }
  
            this.point.push({
  
              index: i,
  
              fLon: el.fLon,
  
              fLat: el.fLat,
  
              iAngle: el.siAngle,
  
              strTime: el.strTime,
  
              iSpeed: el.iSpeed,
  
              id: el?.strUnitId ? el.strUnitId : el.strUnitID,
  
              carName: el.strFullName,
  
              strMobileDomain: el.strMobileDomain_strComment,
  
              strMobileGroup: el.strMobileGroup_strComment,
  
              strMobileType: el.strMobileType_strComment
  
            });
  
            this.pointLive = this.point.filter((els: any) => {
  
              return els.id == el.strUnitID
  
            });
  
            this.mapService.drawRouteAnimate_New(`route${el.strUnitID}`, this.map, this.pointLive, res[i]);
  
          });
  
          if (res.length > 0) {
  
            this.mapService.fitMap(res, this.map);
  
          }
          
        }, 100);


        setTimeout(() => {

          // نمایش مشخصات ماشین

          this.map.on('pointermove', (e: any) => {

            if (e.dragging) {
              //...
              return;
            }

            var el = this.mapService.mapPointerMove(
              this.map.getEventPixel(e.originalEvent),
              this.map
            );

            var pixel = this.map.getEventPixel(e.originalEvent);

            var hit = this.map.hasFeatureAtPixel(pixel);

            this.map.getViewport().style.cursor = hit ? 'pointer' : '';

            this.showData(el, true);

          });

          this.map.on('click', (e: any) => {
            if (e.dragging) {
              //...
              return;
            }
            setTimeout(() => {
              var el = this.mapService.mapPointerMove(
                this.map.getEventPixel(e.originalEvent),
                this.map
              );
              this.showData(el);
            }, 250);
          });

          this.map.getView().on('propertychange', (e: any) => {

            var tooltip = $('#map_tooltip');

            tooltip.tooltip('hide');

            this.tooltipData = null;

          });


        }, 1500);

      }

      else {

        this.route.queryParams.subscribe((params) => {

          if (params['ita']) this.iTempAccess = params['ita'];

          if (params['client']) {

            this.strClientId = params['client'];
          }

          if (params['channel']) {

            this.tiChannel = params['channel'];
          }

          if (params['map']) {

            this.bDotOneMap = params['map'] !== 'false';

          }

          if (params['id']) {

            this.tripId = params['id'];

          }

          if (params['ScreenShot']) {

            this.ScreenShot = params['ScreenShot'] == 'true' ? true : false;

          }

          if (params['time']) {

            this.strValidTime = params['time'];

            this.checkOutTime(true);

          }

        })

        // ترسیم ماشین ها روی نقشه
        setTimeout(() => {

          this.newOpenMap();

          this.route.params.subscribe((params) => {

            this.Id = params['id'];

            ///نمایش همه

            if (this.Id == "trackAll") {

              this.bShowOptions = true;

              this.liveGetCar();

            }

            //نمایش تکی

            else {

              setTimeout(async () => {

                // دسترسی موقت
                if (this.iTempAccess != 0) {

                  var model = {

                    iTemporaryAccess: this.iTempAccess,

                    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

                    strUnitID: this.Id

                  };

                  const resp = await axios.post(`TemporaryAccess_LastPosiation`, this.otherService.stringNumberToNumber(model));

                  resp.data = JSON.parse(resp.data)

                  resp.data = resp.data[0];

                  if (resp.data.bDashCam) {

                    this.getLiveStream();

                  }

                  if (resp.data?.ISSessionExpired == true) {

                    this.otherService.removeLocalStorage();

                    return this.router.navigate(['login']);

                  }

                  if (resp.data == null) return this.notifyService.showError('بروز خطا در سامانه');

                  else {

                    if (resp.data.fLon != this.flon && resp.data.fLat != this.fLat) {

                      this.Name = resp.data.strFullName;

                      this.speed = resp.data.iSpeed;

                      if (resp.data.fDistance) {

                        var num = parseFloat(this.fDistance) + resp.data.fDistance;

                        this.fDistance = (Math.round(num * 100) / 100).toFixed(2)

                      }

                      this.strTime = resp.data.strTime;

                      this.Plak = resp.data.strVehicleNo;

                      if (this.point.length != 0) {

                        this.mapService.removeMarkerById('route', this.map);

                        this.mapService.removeMarkerById('route_start', this.map);

                        this.mapService.removeMarkerById('route_end', this.map);

                      }

                      this.point.push({

                        fLon: resp.data.fLon,

                        fLat: resp.data.fLat,

                        iAngle: resp.data.siAngle,

                        strTime: resp.data.strTime,

                        iSpeed: resp.data.iSpeed,

                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.point, resp.data);

                      this.fitMap(resp.data);

                    }

                  }

                }

                // ردیابی موقت
                if (this.strClientId) {

                  let model = {

                    clientId: this.gurdService.decrypt(localStorage.getItem('clientId')!),

                    token: this.gurdService.decrypt(localStorage.getItem('token')!),

                    strUnitID: this.Id

                  };

                  const resp = await axios_2.post(`GetCar4LiveStream`, this.otherService.stringNumberToNumber(model));

                  if (resp.data.bDashCam) {

                    this.getLiveStream();

                  }

                  if (!this.bDotOneMap) return; // مختصات روی نقشه ترسیم نشود

                  if (resp.data?.ISSessionExpired == true) {

                    window.open('/live?timeOut=true&sessionExpired=true', "_self");

                  }

                  if (resp.data == null) {

                    window.open('/live?timeOut=true&error=true', "_self");

                  }

                  else {

                    if (resp.data.fLon != this.flon && resp.data.fLat != this.fLat) {

                      this.Name = resp.data.strFullName;

                      this.speed = resp.data.iSpeed;

                      if (resp.data.fDistance) {

                        var num = parseFloat(this.fDistance) + resp.data.fDistance;

                        this.fDistance = (Math.round(num * 100) / 100).toFixed(2)

                      }

                      this.strTime = resp.data.strTime;

                      this.Plak = resp.data.strVehicleNo;

                      if (this.point.length != 0) {

                        this.mapService.removeMarkerById('route', this.map);

                        this.mapService.removeMarkerById('route_start', this.map);

                        this.mapService.removeMarkerById('route_end', this.map);

                      }

                      this.point.push({

                        fLon: resp.data.fLon,

                        fLat: resp.data.fLat,

                        iAngle: resp.data.siAngle,

                        strTime: resp.data.strTime,

                        iSpeed: resp.data.iSpeed,

                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.point, resp.data);

                      this.fitMap(resp.data);

                    }

                  }

                }

                // موقعیت و ردیابی
                else {

                  let model = {

                    ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

                    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

                  };

                  const resp = await axios.post(`GetCar?strUnitID=${this.Id}`, this.otherService.stringNumberToNumber(model));

                  if (resp.data?.ISSessionExpired == true) {

                    this.otherService.removeLocalStorage();

                    return this.router.navigate(['login']);

                  }

                  if (resp.data == null) return this.notifyService.showError('بروز خطا در سامانه');

                  else {

                    if (resp.data.fLon != this.flon && resp.data.fLat != this.fLat) {

                      this.Name = resp.data.strFullName;

                      this.speed = resp.data.iSpeed;

                      var num = parseFloat(this.fDistance) + resp.data.fDistance;

                      this.fDistance = (Math.round(num * 100) / 100).toFixed(2)

                      this.strTime = resp.data.strTime;

                      this.Plak = resp.data.strVehicleNo;

                      if (this.point.length != 0) {

                        this.mapService.removeMarkerById('route', this.map);

                        this.mapService.removeMarkerById('route_start', this.map);

                        this.mapService.removeMarkerById('route_end', this.map);

                      }

                      this.point.push({

                        fLon: resp.data.fLon,

                        fLat: resp.data.fLat,

                        iAngle: resp.data.siAngle,

                        strTime: resp.data.strTime,

                        iSpeed: resp.data.iSpeed,

                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.point, resp.data);

                      this.fitMap(resp.data);

                    }

                  }

                }

              }, 700);

              // شبیه سازی موقعیت زنده 

              this.interval = setInterval(async () => {

                // دسترسی موقت
                if (this.iTempAccess != 0) {

                  var model = {

                    iTemporaryAccess: this.iTempAccess,

                    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

                    strUnitID: this.Id

                  };

                  const resp = await axios.post(`TemporaryAccess_LastPosiation`, this.otherService.stringNumberToNumber(model));

                  resp.data = JSON.parse(resp.data)

                  resp.data = resp.data[0];

                  if (resp.data.bDashCam) {

                    this.getLiveStream()

                  }

                  if (resp.data?.ISSessionExpired == true) {

                    this.otherService.removeLocalStorage();

                    this.router.navigate(['login']);

                    return;

                  }

                  if (resp.data == null) {

                    this.notifyService.showError('بروز خطا در سامانه');

                    return;

                  }

                  else {

                    if (resp.data.fLon != this.flon && resp.data.fLat != this.fLat) {

                      this.flon = resp.data.fLon;

                      this.fLat = resp.data.fLat;

                      this.Name = resp.data.strFullName;

                      this.speed = resp.data.iSpeed;

                      var num = parseFloat(this.fDistance) + resp.data.fDistance;

                      this.fDistance = (Math.round(num * 100) / 100).toFixed(2)

                      this.strTime = resp.data.strTime;

                      this.Plak = resp.data.strVehicleNo;

                      if (this.point.length != 0) {

                        this.mapService.removeMarkerById('route', this.map);

                        this.mapService.removeMarkerById('route_start', this.map);

                        this.mapService.removeMarkerById('route_end', this.map);
                      }

                      this.point.push({

                        fLon: resp.data.fLon,

                        fLat: resp.data.fLat,

                        iAngle: resp.data.siAngle,

                        strTime: resp.data.strTime,

                        iSpeed: resp.data.iSpeed,

                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.point, resp.data);

                      this.point.forEach((element: any, index: number) => {

                        if (index % 2 === 0) {

                          if (index > 1) {

                            if (this.point[index - 1].fLon != 0 && this.point[index - 1].fLat != 0) {

                              var marker = this.mapService.craeteArrow(

                                [this.point[index - 1].fLon, this.point[index - 1].fLat],

                                '../../../assets/Img/16.png',

                                `Arrow`,

                                `ArrowName`,

                                {
                                  html: `<span class="text-success">زمان : ${this.point[index - 1].strTime

                                    }</span>
  
                             <br />
  
                             <span class="text-danger">سرعت : ${this.point[index - 1].iSpeed

                                    }</span>
  
                             `,

                                },

                                this.point[index - 1].iAngle
                              );

                              this.map.addLayer(marker);

                            }
                          }
                        }

                      });

                    }
                  }


                }

                // ردیابی موقت
                if (this.strClientId) {

                  let model = {

                    clientId: this.gurdService.decrypt(localStorage.getItem('clientId')!),

                    token: this.gurdService.decrypt(localStorage.getItem('token')!),

                    strUnitID: this.Id

                  };

                  const resp = await axios_2.post(`GetCar4LiveStream`, this.otherService.stringNumberToNumber(model));

                  if (resp.data.bDashCam) {

                    this.getLiveStream();

                  }

                  if (!this.bDotOneMap) return; // مختصات روی نقشه ترسیم نشود

                  if (resp.data?.ISSessionExpired == true) {

                    window.open('/live?timeOut=true&sessionExpired=true', "_self");

                  }

                  if (resp.data == null) {

                    window.open('/live?timeOut=true&error=true', "_self");

                  }

                  else {

                    if (resp.data.fLon != this.flon && resp.data.fLat != this.fLat) {

                      this.Name = resp.data.strFullName;

                      this.speed = resp.data.iSpeed;

                      if (resp.data.fDistance) {

                        var num = parseFloat(this.fDistance) + resp.data.fDistance;

                        this.fDistance = (Math.round(num * 100) / 100).toFixed(2)

                      }

                      this.strTime = resp.data.strTime;

                      this.Plak = resp.data.strVehicleNo;

                      if (this.point.length != 0) {

                        this.mapService.removeMarkerById('route', this.map);

                        this.mapService.removeMarkerById('route_start', this.map);

                        this.mapService.removeMarkerById('route_end', this.map);

                      }

                      this.point.push({

                        fLon: resp.data.fLon,

                        fLat: resp.data.fLat,

                        iAngle: resp.data.siAngle,

                        strTime: resp.data.strTime,

                        iSpeed: resp.data.iSpeed,

                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.point, resp.data);

                      this.fitMap(resp.data);

                    }

                  }

                }

                // موقعیت و ردیابی
                else {

                  let model = {

                    ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

                    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

                  };

                  const resp = await axios.post(`GetCar?strUnitID=${this.Id}`, this.otherService.stringNumberToNumber(model));

                  if (resp.data?.ISSessionExpired == true) {

                    this.otherService.removeLocalStorage();

                    this.router.navigate(['login']);

                    return;

                  }

                  if (resp.data == null) {

                    this.notifyService.showError('بروز خطا در سامانه');

                    return;

                  }

                  else {

                    if (resp.data.fLon != this.flon && resp.data.fLat != this.fLat) {

                      this.flon = resp.data.fLon;

                      this.fLat = resp.data.fLat;

                      this.Name = resp.data.strFullName;

                      this.speed = resp.data.iSpeed;

                      var num = parseFloat(this.fDistance) + resp.data.fDistance;

                      this.fDistance = (Math.round(num * 100) / 100).toFixed(2)

                      this.strTime = resp.data.strTime;

                      this.Plak = resp.data.strVehicleNo;

                      if (this.point.length != 0) {

                        this.mapService.removeMarkerById('route', this.map);

                        this.mapService.removeMarkerById('route_start', this.map);

                        this.mapService.removeMarkerById('route_end', this.map);
                      }

                      this.point.push({

                        fLon: resp.data.fLon,

                        fLat: resp.data.fLat,

                        iAngle: resp.data.siAngle,

                        strTime: resp.data.strTime,

                        iSpeed: resp.data.iSpeed,

                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.point, resp.data);

                      this.point.forEach((element: any, index: number) => {

                        if (index % 2 === 0) {

                          if (index > 1) {

                            if (this.point[index - 1].fLon != 0 && this.point[index - 1].fLat != 0) {

                              var marker = this.mapService.craeteArrow(

                                [this.point[index - 1].fLon, this.point[index - 1].fLat],

                                '../../../assets/Img/16.png',

                                `Arrow`,

                                `ArrowName`,

                                {
                                  html: `<span class="text-success">زمان : ${this.point[index - 1].strTime}</span>
  
                             <br />
  
                             <span class="text-danger">سرعت : ${this.point[index - 1].iSpeed}</span>
  
                             `,

                                },

                                this.point[index - 1].iAngle
                              );

                              this.map.addLayer(marker);

                            }
                          }
                        }

                      });

                    }
                  }

                }

              }, 5000);

            }

          });

        }, 500);

        // نمایش مشخصات ماشین
        setTimeout(() => {

          if (this.Id == "trackAll") {

            this.map.on('pointermove', (e: any) => {

              if (e.dragging) {
                //...
                return;
              }

              var el = this.mapService.mapPointerMove(
                this.map.getEventPixel(e.originalEvent),
                this.map
              );

              var pixel = this.map.getEventPixel(e.originalEvent);

              var hit = this.map.hasFeatureAtPixel(pixel);

              this.map.getViewport().style.cursor = hit ? 'pointer' : '';

              this.showData(el, true);

            });

          }

          this.map.on('click', (e: any) => {
            if (e.dragging) {
              //...
              return;
            }
            setTimeout(() => {
              var el = this.mapService.mapPointerMove(
                this.map.getEventPixel(e.originalEvent),
                this.map
              );
              this.showData(el);
            }, 250);
          });

          this.map.getView().on('propertychange', (e: any) => {
            var tooltip = $('#map_tooltip');
            tooltip.tooltip('hide');
            this.tooltipData = null;
          });

        }, 1500);

        this.getDomain();

        this.getGroup();

      }

    })

  }

  ngOnDestroy(): void {

    clearInterval(this.interval);

    var tooltip = $('#map_tooltip');

    tooltip.tooltip('hide');

    window.localStorage.removeItem('clientId');

    window.localStorage.removeItem('token');


  }

  newOpenMap() {

    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({
      source: this.source,
    });

    if (this.bOfflineMap) {

      this.layers.push(

        new TileLayer({

          source: new XYZ({

            // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr' // 

          }),

        })

      );

    }

    else {

      const styles = [

        'AerialWithLabelsOnDemand',

      ];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {

        this.layers.push(

          new TileLayer({

            visible: false,

            preload: Infinity,

            source: new BingMaps({

              // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


              imagerySet: styles[i],

            }),

          }),

        );
      }

      this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


    }

    this.map = new Map({
      controls: defaultControls().extend([]),
      layers: this.layers,
      target: 'test',
      view: new View({
        center: olProj.fromLonLat([51.3833554, 35.6770113]),
        zoom: 13,
      }),
    });

  }

  fitMap(data?: any) {
    if (data == null) {
      data = this.car;
    }
    var maxLatitude = data.fLat;

    var maxLongitude = data.fLon;

    var minLatitude = data.fLat;
    var minLongitude = data.fLon;

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([
      maxLongitude,
      maxLatitude,
    ]);
    var transformedEnd = this.mapService.transformCoordinates2([
      minLongitude,
      minLatitude,
    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 300,
      Math.min(transformedStart[1], transformedEnd[1]) - 300,
      Math.max(transformedStart[0], transformedEnd[0]) + 300,
      Math.max(transformedStart[1], transformedEnd[1]) + 300,
      // Math.min(transformedStart[0], transformedEnd[0]) - 2000,
      // Math.min(transformedStart[1], transformedEnd[1]) - 2000,
      // Math.max(transformedStart[0], transformedEnd[0]) + 2000,
      // Math.max(transformedStart[1], transformedEnd[1] + 2000)
    ];
    view.fit(source);
  }

  showData(item: any, hover?: any) {

    var tooltip: any;

    if (!hover) {

      tooltip = $('#map_tooltip');

    }

    else {
      tooltip = $('#map_tooltips');
    }

    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });

    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });

    if (item.featureLayer) {

      if (item.featureLayer.feature.get('data')) {

        if (!hover) {

          this.tooltipData = item.featureLayer.feature.get('data').html;

          tooltip.attr('data-bs-original-title', item.featureLayer.feature.get('data').html).tooltip('show');

          var hoverTooltip = $('#map_tooltips');

          hoverTooltip.tooltip('hide');

        }

        else {
          if (this.tooltipData == item.featureLayer.feature.get('data').html) {
            return
          } else {
            ///////
            tooltip
              .attr(
                'data-bs-original-title',
                item.featureLayer.feature.get('data').html2
              )

              .tooltip('show');
          }
        }

        $('#map-button').click(() => {
          this.router.navigate([
            `/carInfo/${item.featureLayer.feature.get('data').Id}`,
          ]);
          tooltip.tooltip('hide');
          var hoverTooltip = $('#map_tooltip');
          hoverTooltip.tooltip('hide');
        });

      }

    }

    else {
      tooltip.tooltip('hide');
      this.tooltipData = null;
    }

  }

  getLiveStream = async () => {

    this.checkOutTime();

    if (this.lst_checked.length > 0) return;

    this.bDashCam = true;

    let model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.Id,

      ClientId: this.gurdService.decrypt(localStorage.getItem('clientId')!) || '',

      Token: this.gurdService.decrypt(localStorage.getItem('token')!) || '',

    }

    this.otherService.Showspinner();

    const resp = await axios.post(`Dashcam_CheckOnlineFull`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) {

      return this.notifyService.showError(res.strError);

    }

    if (res.Online) {

      if (res.Ch1 == 1 && this.tiChannel == 0) {

        const dashCam = this.lst_checked.find((cam: any) => cam.strUnitId == res.IMEI + '-0');

        if (!dashCam) {

          res.strUnitID = res.IMEI;

          this.checkOut_OnlineCam([res])

        }

      }

      if (res.Ch2 == 1 && this.tiChannel == 1) {

        const dashCam = this.lst_checked.find((cam: any) => cam.strUnitId == res.IMEI + '-1');

        if (!dashCam) {

          res.strUnitID = res.IMEI;

          this.checkOut_OnlineCam([res])

        }

      }

      else {

        const dashCam = {

          strUnitId: this.Id + '-' + this.tiChannel,

          iDeviceCommand: 'ندارد',

          fullName: this.Name,

          channel: this.tiChannel == 0 ? 'وقایع' : 'کابین',

          strUrl: '',

        }

        const index = this.lst_checked.indexOf(dashCam);

        if (index == -1) {

          this.lst_checked.push(dashCam);

        }

      }

    }

    else {

      const dashCam = {

        strUnitId: this.Id + '-' + this.tiChannel,

        iDeviceCommand: 'ندارد',

        fullName: this.Name,

        channel: this.tiChannel == 0 ? 'وقایع' : 'کابین',

        strUrl: '',

      }

      const index = this.lst_checked.indexOf(dashCam);

      if (index == -1) {

        this.lst_checked.push(dashCam);

      }

    }

  }

  private checkOutTime(initialize: boolean = false) {

    if (this.strValidTime) {

      const ts = Number(this.strValidTime);

      const now = new Date().getTime();

      // If called from ngOnInit

      if ((ts * 1000) <= now && initialize) {

        window.open('/live?timeOut=true', "_self");

      }

      else if ((ts * 1000) <= now) {

        clearInterval(this.interval);

      }

    }

  }

  async checkOut_OnlineCam(response) {

    response.forEach((car) => {

      if (car.Online) {

        if (car.Ch1 == 1 && this.tiChannel == 0) {

          const dashCam = {

            strUnitId: car.strUnitID + '-0',

            iDeviceCommand: 'ندارد',

            fullName: car.strFullName,

            channel: 'وقایع',

            strUrl: car.strCh1FLVURL,

          }

          const index = this.lst_checked.indexOf(dashCam);

          if (index == -1) {

            this.lst_checked.push(dashCam);

          }

        }

        if (car.Ch2 == 1 && this.tiChannel == 1) {

          const dashCam = {

            strUnitId: car.strUnitID + '-1',

            iDeviceCommand: 'ندارد',

            fullName: car.strFullName,

            channel: 'کابین',

            strUrl: car.strCh2FLVURL,

          }

          const index = this.lst_checked.indexOf(dashCam);

          if (index == -1) {

            this.lst_checked.push(dashCam);

          }

        }

      }

    })

  }

  async failedRequest(item) {

    // console.log('bye ' + item.strUnitId)

    const dashCam = this.lst_checked.find((cam: any) => cam.strUnitId == item.strUnitId);

    const index = this.lst_checked.indexOf(dashCam);

    if (index != -1) {

      // console.log(dashCam)

      // console.log(index)

      this.lst_checked.splice(index, 1);

    }

  }

  async updateCheckedList(item) {

    const dashCam = this.lst_checked.find((cam: any) => cam.strUnitId == item.strUnitId);

    if (!dashCam) {

      this.lst_checked.push(item);

      // this.updateView();


    }

    else {

      const index = this.lst_checked.indexOf(dashCam);

      if (index != -1) {

        this.lst_checked[index] = dashCam;

        // console.log(dashCam);

      }


    }

  }

  goBack() {

    if (this.iTempAccess != 0) return this.router.navigate(['ta'], { queryParams: { ita: this.iTempAccess } });

    if (this.Id == "trackAll") return this.router.navigateByUrl('/');

    else return this.router.navigate(['carInfo', this.Id])

  }

  guid() {
    this.otherService.guid(2);
  }

  changeTail() {

    if (this.mapSatelait == false) {
      this.layers[1].setVisible(false);

      this.layers[0].setVisible(true);
    }
    else {
      this.layers[0].setVisible(false);

      this.layers[1].setVisible(true);
    }
    this.mapSatelait = !this.mapSatelait;

  }

  liveGetCar = async () => {

    this.otherService.Showspinner();

    var iMobileDomain = document.getElementById("domain") as any;

    var tiMobileType = document.getElementById("groupCar") as any;

    var model = this.otherService.stringNumberToNumber({

      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iMobileDomain: iMobileDomain?.value || -1,

      tiMobileType: tiMobileType?.value || -1,

      bFromWeb: true,

      bWithIcon: true,

      bOnlyHasGPS: true,

      strUnitID: "",

      strLastCallTime: this.lastCallTime

    });

    this.mapService.removeLayerByName(`route_point`, this.map);

    this.mapService.removeLayerByName(`route_start`, this.map);

    this.mapService.removeLayerByName(`route_end`, this.map);

    this.mapService.removeLayerByName(`ArrowName`, this.map);

    const resp = await axios.post(`FleetYar_Car_List_New `, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    if (resp.data.length) this.lastCallTime = resp.data[0].strLastCallTime;

    if (resp.data?.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (resp.data == null) {

      this.notifyService.showError('بروز خطا در سامانه');

      return;

    }

    else {

      resp.data.forEach((el: any, i: any) => {

        if (this.point.length != 0) {

          this.mapService.removeMarkerById(`route${el.strUnitID}`, this.map);

          this.mapService.removeMarkerById(`route${el.strUnitID}_start`, this.map);

          this.mapService.removeMarkerById(`route${el.strUnitID}_end`, this.map);

          this.mapService.removeLayerByName(`ArrowName`, this.map);

          this.mapService.removeLayerByName(`route_line`, this.map);

          this.mapService.removeLayerByName(`route_point`, this.map);

        }

        this.point.push({

          index: i,

          fLon: el.fLon,

          fLat: el.fLat,

          iAngle: el.siAngle,

          strTime: el.strTime,

          iSpeed: el.iSpeed,

          id: el?.strUnitId ? el.strUnitId : el.strUnitID,

          carName: el.strFullName,

          strMobileDomain: el.strMobileDomain_strComment,

          strMobileGroup: el.strMobileGroup_strComment,

          strMobileType: el.strMobileType_strComment

        });

        this.pointLive = this.point.filter((els: any) => {

          return els.id == el.strUnitID

        });

        this.mapService.drawRouteAnimate_New(`route${el.strUnitID}`, this.map, this.pointLive, resp.data[i]);

      });

      if (resp.data.length > 0) {

        this.mapService.fitMap(resp.data, this.map);

      }

    }

    // ترسیم موقعیت جدید خودروها هر 30 ثانیه

    clearInterval(this.interval);

    this.interval = setInterval(async () => {

      var model_New = this.otherService.stringNumberToNumber({

        ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

        iMobileDomain: iMobileDomain?.value || -1,

        // iMobileDomain: iMobileDomain.value,

        tiMobileType: tiMobileType?.value || -1,

        bFromWeb: true,

        bWithIcon: true,

        bOnlyHasGPS: true,

        strUnitID: "",

        strLastCallTime: this.lastCallTime || ''

      });

      const resp = await axios.post(`FleetYar_Car_List_New`, this.otherService.stringNumberToNumber(model_New));

      if (!resp.data.length) return;

      this.lastCallTime = resp.data[0].strLastCallTime;

      if (resp.data?.ISSessionExpired == true) {

        this.otherService.removeLocalStorage();

        this.router.navigate(['login']);

        return;

      }

      if (resp.data == null) {

        this.notifyService.showError('بروز خطا در سامانه');

        return;

      }

      // ترسیم روی نقشه

      else {

        this.point = []; // make an array empty to only update received data

        resp.data.forEach((el: any, i: any) => {

          this.mapService.removeMarkerById(`route${el.strUnitID}`, this.map);

          this.mapService.removeMarkerById_New(`route${el.strUnitID}_start`, this.map);

          this.mapService.removeMarkerById_New(`route${el.strUnitID}_end`, this.map);

          this.point.push({

            index: i,

            fLon: el.fLon,

            fLat: el.fLat,

            iAngle: el.siAngle,

            strTime: el.strTime,

            iSpeed: el.iSpeed,

            id: el.strUnitID,

            carName: el.strFullName,

            strMobileDomain: el.strMobileDomain_strComment,

            strMobileGroup: el.strMobileGroup_strComment,

            strMobileType: el.strMobileType_strComment

          });

          this.pointLive = this.point.filter((els: any) => {

            return els.id == el.strUnitID

          });

          if (this.pointLive.length > 10) {

            this.pointLive.shift();

            this.point.splice(this.pointLive[0].index, 1);

          }

          this.mapService.drawRouteAnimate_New(`route${el.strUnitID}`, this.map, this.pointLive, resp.data[i]);

        });

      }

    }, 30000);

  }

  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
      {}
    );
    this.domain = JSON.parse(resp.data);

  }

  getGroup = async () => {
    const resp = await axios.post(`GetMobileType`, {});
    this.groupCar = resp.data;
  };

}
